import * as React from "react";
const Humidity = ({ color, height, width }) => (
    <svg
        width={width} height={height}
        viewBox="0 0 61 61"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.6748 22.574C24.6748 24.0746 25.2709 25.5137 26.332 26.5748C27.3931 27.6359 28.8322 28.232 30.3328 28.232C31.8334 28.232 33.2725 27.6359 34.3336 26.5748C35.3947 25.5137 35.9908 24.0746 35.9908 22.574C35.9908 19.442 30.3328 11.258 30.3328 11.258C30.3328 11.258 24.6748 19.442 24.6748 22.574Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.3311 44.084C11.3311 45.5846 11.9272 47.0237 12.9882 48.0848C14.0493 49.1459 15.4885 49.742 16.9891 49.742C18.4896 49.742 19.9288 49.1459 20.9899 48.0848C22.0509 47.0237 22.6471 45.5846 22.6471 44.084C22.6471 40.958 16.9891 32.768 16.9891 32.768C16.9891 32.768 11.3311 40.958 11.3311 44.084Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M43.6766 32.768C43.6766 32.768 38.0186 40.958 38.0186 44.084C38.0186 45.5846 38.6147 47.0237 39.6757 48.0848C40.7368 49.1459 42.176 49.742 43.6766 49.742C45.1771 49.742 46.6163 49.1459 47.6774 48.0848C48.7384 47.0237 49.3346 45.5846 49.3346 44.084C49.3346 40.958 43.6766 32.768 43.6766 32.768Z"
            fill={color}
        />
    </svg>
);
export default Humidity;
